import CreateAccountState, { initialState } from "@affinity/Store/AffinityCreateAccountState";
import { CreateAccountStep } from "@affinity/Store/StoreTypes";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { CreateOrRequestQuote } from "@insite/client-framework/Store/Pages/RfqRequestQuote/Handlers/CreateOrRequestQuote";
import { BillToModel, ShipToCollectionModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";
import TagPresentationPropsDefault from "@insite/mobius/Tag/presentationProps";
import { Draft, isDraft } from "immer";

const reducer = {
    "Affinity/CreateAccount/Step1CreateAccount": (
        draft: Draft<CreateAccountState>,
        action: { firstName: string, lastName: string, contactNumber: string, emailAddress: string, billTo: BillToModel },
    ) => {
        draft.currentStep = CreateAccountStep.Second;
        // TODO CREATE ACCOUNT AND ANY EXTRA LOGIC
        draft.firstName = action.firstName;
        draft.lastName = action.lastName;
        draft.contactNumber = action.contactNumber;
        draft.emailAddress = action.emailAddress;
        draft.billTo = action.billTo;
        // Likely to rafactor above to be a User ID created by handler or a Bill To account
    },
    // TODO ADD INITIAL STATE SETUP AS WANT TO GET TARGET URL ETC, ALT CMS PROPERTIES IN STEP SO UPDATE IN STEP WORK
    "Affinity/CreateAccount/SetAddresses": (
        draft: Draft<CreateAccountState>,
        action: { addressCollection: ShipToCollectionModel },
    ) => {
        draft.currentStep = CreateAccountStep.Second; // Maintain second step, select an address to progress
        draft.existingAddresses = action.addressCollection;
    },
    "Affinity/CreateAccount/SetAddress": (
        draft: Draft<CreateAccountState>,
        action: { address: ShipToModel },
    ) => {
        draft.currentStep = CreateAccountStep.Third;
        draft.selectedAddress = action.address;
    },
    "Affinity/CreateAccount/SetComplete": (
        draft: Draft<CreateAccountState>,
        action: { targetUrl: string | undefined },
    ) => {
        draft.currentStep = CreateAccountStep.Complete;
        if (action.targetUrl) {
            draft.targetUrl = action.targetUrl;
        }
    },
    "Affinity/CreateAccount/SwitchAddressMode": (
        draft: Draft<CreateAccountState>,
        action: { value: boolean | undefined }
    ) => {
        if (action.value) {
            draft.isAddingAddress = action.value;
        } else {
            draft.isAddingAddress = !draft.isAddingAddress;
        }
    },
}

export default createTypedReducerWithImmer(initialState, reducer);
// export default createTypedReducerWithImmer(mockState, reducer);